import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    AccountFilterRequestResponse,
} from 'app/Apps/AccountManagement/Accounts/Account.types'
import {
    AccountStatus,
} from 'app/enums/label.enums'

const config: SkyNetTableConfig<keyof AccountFilterRequestResponse> = {
    name: 'Account',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'companyName',
                labelKey: 'Accounts.accountCompany',
                filterField: 'companyName',
                filterType: FilterType.Array,
                reduced: true,
            },
            {
                name: 'accountOwner',
                labelKey: 'Accounts.accountOwner',
                filterField: 'accountOwner',
                filterType: FilterType.Array,
            },
            {
                name: 'isStrategicAccount',
                labelKey: 'Accounts.strategicAccount',
                componentName: 'ChipCheckMark',
            },
            {
                name: 'collaborators',
                labelKey: 'Accounts.collaborators',
                componentName: 'List',
                filterField: 'collaborators',
                filterType: FilterType.Array,
            },
            {
                name: 'accountStatus',
                labelKey: 'Accounts.status',
                componentName: 'EnumValue',
                allowedValuesEnum: AccountStatus,
                filterField: 'accountStatus',
                filterType: FilterType.Array,
            },
            {
                name: 'createdOn',
                labelKey: 'Accounts.createdOn',
                componentName: 'DateTimeCell',
            },
        ],
    }],

}

export default config
